import TeamAssistConfiguration from 'models/team_assist_configuration';

export default class TeamAssistConfigurationGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onBroadcast(dto) {
    this.context.stores.teamAssistConfiguration.set(TeamAssistConfiguration.fromJs(dto));
  }
}
